// src/utils/unsplashAttribution.ts

// `utm_source` musi się zgadzać z nazwą aplikacji zarejestrowanej u Unsplasha. Od rotacji klucza
// (24.09.2026) to nowa aplikacja `elk`. Backend zapisuje adresy bez UTM, więc ta stała jest jedynym
// miejscem w całym systemie, gdzie ta nazwa żyje — przy kolejnej zmianie aplikacji zmienia się tylko tu.
const UTM = 'utm_source=elk&utm_medium=referral';

// Wytyczne Unsplash API wymagają UTM przy linkach do autora i do zdjęcia. Backend zapisuje
// adresy czyste, więc doklejenie zostaje sprawą renderowania — i stare wiersze (sprzed fazy 0)
// traktujemy dokładnie tak samo jak nowe.
export const withUnsplashUtm = (url?: string): string | undefined => {
  if (!url) {
    return undefined;
  }

  return url.includes('?') ? `${url}&${UTM}` : `${url}?${UTM}`;
};

// Zdjęcie z Unsplasha rozpoznajemy po adresie, nie po metadanych — tylko tak da się złapać
// słowa sprzed września, które nie mają `imageMeta` wcale.
export const isUnsplashImage = (url?: string): boolean => {
  if (!url) {
    return false;
  }

  try {
    const { hostname } = new URL(url);

    return hostname === 'unsplash.com' || hostname.endsWith('.unsplash.com');
  } catch {
    return false;
  }
};

// Zdjęcie z Unsplasha bez znanego autora: ~3265 słów wybranych, zanim zaczęliśmy zapisywać
// atrybucję. Autora nie da się już odzyskać (F15), ale wytyczne i tak wymagają wskazania źródła —
// takie słowo dostaje ogólny podpis z linkiem do platformy.
export const isUnsplashWithoutAuthor = (word: any): boolean => Boolean(
  word?.image && !word?.imageMeta?.authorName && isUnsplashImage(word.image),
);
